import { render, staticRenderFns } from "./TariffCarousel.vue?vue&type=template&id=6f5c7246&lang=pug&"
import script from "./TariffCarousel.vue?vue&type=script&lang=js&"
export * from "./TariffCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TariffCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports